import { Dialog, Transition } from "@headlessui/react";
import BadgeLogoIcon from "../../../Icons/BadgeLogoIcon";
import { XMarkIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import config from "../../../config";
import NoData from "../../../Icons/NoData";
import { useLoader } from "../../../hooks/LoaderContext";

function Leaderboard({ isOpen = false, onClose, title, contest_id, lang }) {
  //const { showToast } = useToast();
  const cancelButtonRef = useRef(null);
  const [topfivedata, settopfiveData] = useState({});
  const [nextfiveData, setnextfiveData] = useState({});
  const [subsbadgeCounts, setsubsbadgeCounts] = useState({});
  const [subsbadgeCountsNxt, setsubsbadgeCountsNxt] = useState({});
  const { showLoader, hideLoader } = useLoader();

  const fetchBadgeCounts = useCallback(async () => {
    
    if (topfivedata.length === 0) return;

    try {
      const response = await axios.post(`${config.API_URL}/get-badge-count`, {
        contest_member_id: topfivedata.map(
          (topfivedata) => topfivedata.contest_member_id
        ),
        contest_id: contest_id,
      });
      setsubsbadgeCounts(response.data.badgecount);
    } catch (error) {
      console.error("Error fetching Badge counts", error);
    } finally {
      //hideLoader();
    }
  }, [contest_id, topfivedata]);

  const fetchBadgeCountsNext = useCallback(async () => {
    
    if (nextfiveData.length === 0) return;

    try {
      const response = await axios.post(`${config.API_URL}/get-badge-count`, {
        contest_member_id: nextfiveData.map(
          (nextfiveData) => nextfiveData.contest_member_id
        ),
        contest_id: contest_id,
      });
      setsubsbadgeCountsNxt(response.data.badgecount);
    } catch (error) {
      console.error("Error fetching Badge counts", error);
    } finally {
      //hideLoader();
    }
  }, [contest_id, nextfiveData]);

  useEffect(() => {
    if (topfivedata.length > 0) {
      fetchBadgeCounts(topfivedata);
    }
  }, [topfivedata, fetchBadgeCounts]);

  useEffect(() => {
    if (nextfiveData.length > 0) {
      fetchBadgeCountsNext(nextfiveData);
    }
  }, [nextfiveData, fetchBadgeCountsNext]);

  const getTopFiveLeaderboardList = useCallback(async () => {
    showLoader();
    const session_member = sessionStorage.getItem("member_" + contest_id);

    if (session_member) {
      const memberDet = JSON.parse(session_member);
      try {
        let payload = {
          contest_id: contest_id,
          contest_member_id: memberDet.contest_member_id,
        };
        const res = await axios.post(
          `${config.API_URL}/get-leaderboard-details`,
          payload
        );

        if (res.status === 200) {
          // console.log(res.data.topfivelist);
          if (res.data.topfivelist) {
            settopfiveData(res.data.topfivelist);
          }
          if (res.data.nextfivelist) {
            setnextfiveData(res.data.nextfivelist);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        hideLoader();
      }
    }
  }, [contest_id,showLoader,hideLoader]);

  useEffect(() => {
    if (isOpen) {
      getTopFiveLeaderboardList();
    }
  }, [isOpen, getTopFiveLeaderboardList]);

  function getFirstLetter(name) {
    if (name && name.length > 0) {
      return name.charAt(0).toUpperCase(); // You can use toUpperCase() to make it uppercase
    }
    return ""; // Return empty string if name is empty
  }

  const topFive = topfivedata || [];

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto flex items-center justify-center p-4">
          {/* <div className="flex min-h-full items-center justify-center p-4 text-center"> */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-[724px] h-auto max-h-[90vh] sm:max-h-[801px]">
              <div className="bg-white ">
                <div className="flex items-center justify-between border-b  px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-bold text-gray-900 flex items-center gap-3"
                  >
                    <BadgeLogoIcon width={50} />
                    <div>
                      <h2>{title}</h2>
                      <p className="text-sm font-normal text-gray-500">
                        {lang?.contest_participants_position ||
                          "Contest participants will be displayed based on their position."}
                      </p>
                    </div>
                  </Dialog.Title>
                  <button
                    type="button"
                    className="absolute right-3 top-3 rounded-md bg-[#E5E5E5A3]  p-1 text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon
                      className="h-5 w-5 text-black"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                {/* leaderboard */}

                <div className="">
                  <h2 className="text-center text-base font-normal py-5 bg-[#EEEEEE] border-y border-gray-300">
                    {lang?.top_five_leaderboard || "Top 5 LeaderBoard"}
                  </h2>
                  <div className="max-h-[350px] overflow-y-auto scrollbar-custom">
                    {Array.isArray(topfivedata) && topfivedata.length > 0 ? (
                      <div className="max-w-[724px] max-h-[751px]">
                        <div className="bg-white p-4 pb-6">
                          <div className="overflow-x-auto scrollbar-custom sm:overflow-visible hidden sm:flex">
                            {/* Large Screen View */}
                            <div className="inline-flex items-end justify-start mx-auto gap-4 min-w-max pt-2">
                              {/* 4th */}
                              {topFive[3] && (
                                <div className="w-[118px] flex flex-col items-center">
                                  <div className="primary_border_color border border-[#5CA8FF] rounded-full w-[56px] h-[56px] flex items-center justify-center relative">
                                    <span className="primary_bg absolute left-[13px] -translate-x-1/2 top-[13%] -translate-y-1/2 w-[27px] h-[42px] bg-[#0274F7] clip-path-triangle transform -skew-y-12">
                                      <span className="text-white text-sm font-bold absolute top-[28%] left-[18%]">
                                        {topFive[3]?.rank_position}
                                      </span>
                                    </span>
                                    <span className="text-[17px] text-bold">
                                      {getFirstLetter(topFive[3].name) || "N/A"}
                                    </span>
                                  </div>
                                  <div className="mt-2 text-center">
                                    <p className="text-sm font-normal">
                                      {topFive[3].name || "No Name"}
                                    </p>
                                    <div className="flex justify-center gap-1 text-[12px] font-semibold text-[#0274F7]">
                                      <span className="border-r border-gray-400 pr-1 primary_text_color">
                                        {topFive[3].points || 0}{" "}
                                        {lang?.points || "Points"}
                                      </span>
                                      <span className="pl-1 primary_text_color">
                                        {subsbadgeCounts[
                                          topFive[3]?.contest_member_id
                                        ] || 0}{" "}
                                        {lang?.badges || "Badges"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* 2nd */}
                              {topFive[1] && (
                                <div className="w-[118px] flex flex-col items-center">
                                  <div className="primary_border_color border border-[#5CA8FF] rounded-full w-[74px] h-[74px] flex items-center justify-center relative">
                                    <span className="primary_bg absolute left-[13px] -translate-x-1/2 top-[13%] -translate-y-1/2 w-[27px] h-[42px] bg-[#0274F7] clip-path-triangle transform -skew-y-12">
                                      <span className="text-white text-sm font-bold absolute top-[28%] left-[18%]">
                                        {topFive[1]?.rank_position}
                                      </span>
                                    </span>
                                    <span className="text-[23px] text-bold">
                                      {getFirstLetter(topFive[1].name) || "N/A"}
                                    </span>
                                  </div>
                                  <div className="mt-2 text-center">
                                    <p className="text-sm font-normal">
                                      {topFive[1].name}
                                    </p>
                                    <div className="flex justify-center gap-1 text-[12px] font-semibold text-[#0274F7]">
                                      <span className="border-r border-gray-400 pr-1 primary_text_color">
                                        {topFive[1].points}{" "}
                                        {lang?.points || "Points"}
                                      </span>
                                      <span className="pl-1 primary_text_color">
                                        {subsbadgeCounts[
                                          topFive[1]?.contest_member_id
                                        ] || 0}{" "}
                                        {lang?.badges || "Badges"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* 1st */}
                              {topFive[0] && (
                                <div className="w-[118px] flex flex-col items-center">
                                  <div className="primary_border_color border border-[#F19C29] rounded-full w-[94px] h-[94px] flex items-center justify-center relative">
                                    <span className="primary_bg absolute left-[13px] -translate-x-1/2 top-[13%] -translate-y-1/2 w-[27px] h-[42px] bg-[#F19C29] clip-path-triangle transform -skew-y-12">
                                      <span className="text-white text-sm font-bold absolute top-[26%] left-[18%]">
                                        {topFive[0]?.rank_position}
                                      </span>
                                    </span>
                                    <span className="text-[36px] text-bold">
                                      {getFirstLetter(topFive[0].name) || "N/A"}
                                    </span>
                                  </div>
                                  <div className="mt-2 text-center">
                                    <p className="text-sm font-normal">
                                      {topFive[0].name}
                                    </p>
                                    <div className="flex justify-center gap-1 text-[12px] font-semibold text-[#F19C29]">
                                      <span className="border-r border-gray-400 pr-1 primary_text_color">
                                        {topFive[0].points}{" "}
                                        {lang?.points || "Points"}
                                      </span>
                                      <span className="pl-1 primary_text_color">
                                        {subsbadgeCounts[
                                          topFive[0]?.contest_member_id
                                        ] || 0}{" "}
                                        {lang?.badges || "Badges"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* 3rd */}

                              {topFive[2] && (
                                <div className="w-[118px] flex flex-col items-center">
                                  <div className="primary_border_color border border-[#5CA8FF] rounded-full w-[74px] h-[74px] flex items-center justify-center relative">
                                    <span className="primary_bg absolute left-[13px] -translate-x-1/2 top-[13%] -translate-y-1/2 w-[27px] h-[42px] bg-[#0274F7] clip-path-triangle transform -skew-y-12">
                                      <span className="text-white text-sm font-bold absolute top-[28%] left-[18%]">
                                        {topFive[2]?.rank_position}
                                      </span>
                                    </span>
                                    <span className="text-[23px] text-bold">
                                      {getFirstLetter(topFive[2].name) || "N/A"}
                                    </span>
                                  </div>
                                  <div className="mt-2 text-center">
                                    <p className="text-sm font-normal">
                                      {topFive[2].name}
                                    </p>
                                    <div className="flex justify-center gap-1 text-[12px] font-semibold text-[#0274F7]">
                                      <span className="border-r border-gray-400 pr-1 primary_text_color">
                                        {topFive[2].points}{" "}
                                        {lang?.points || "Points"}
                                      </span>
                                      <span className="pl-1 primary_text_color">
                                        {subsbadgeCounts[
                                          topFive[2]?.contest_member_id
                                        ] || 0}{" "}
                                        {lang?.badges || "Badges"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}

                              {/* 5th */}
                              {topFive[4] && (
                                <div className="w-[118px] flex flex-col items-center">
                                  <div className="primary_border_color border border-[#5CA8FF] rounded-full w-[56px] h-[56px] flex items-center justify-center relative">
                                    <span className="primary_bg absolute left-[13px] -translate-x-1/2 top-[13%] -translate-y-1/2 w-[27px] h-[42px] bg-[#0274F7] clip-path-triangle transform -skew-y-12">
                                      <span className="text-white text-sm font-bold absolute top-[28%] left-[18%]">
                                        {topFive[4]?.rank_position}
                                      </span>
                                    </span>
                                    <span className="text-[17px] text-bold">
                                      {getFirstLetter(topFive[4].name) || "N/A"}
                                    </span>
                                  </div>
                                  <div className="mt-2 text-center">
                                    <p className="text-sm font-normal">
                                      {topFive[4].name}
                                    </p>
                                    <div className="flex justify-center gap-1 text-[12px] font-semibold text-[#0274F7]">
                                      <span className="border-r border-gray-400 pr-1 primary_text_color">
                                        {topFive[4].points}{" "}
                                        {lang?.points || "Points"}
                                      </span>
                                      <span className="pl-1 primary_text_color">
                                        {subsbadgeCounts[
                                          topFive[4]?.contest_member_id
                                        ] || 0}{" "}
                                        {lang?.badges || "Badges"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Mobile View */}
                          <div className="flex flex-col gap-2 items-center sm:hidden">
                            {topFive.map((contestant, index) => (
                              <div
                                key={index}
                                className="flex items-center justify-between w-full bg-white shadow-md rounded-lg p-3 border border-gray-300"
                              >
                                {/* First Letter Circle */}
                                <div className="w-8 h-8 primary_border_color primary_bg text-white flex items-center justify-center rounded-full text-lg font-bold">
                                  {getFirstLetter(contestant.name) || "N/A"}
                                </div>

                                {/* Contestant Details */}
                                <div className="flex-1 text-left ml-4">
                                  <p className="text-sm font-medium text-gray-900">
                                    {contestant.name || "No Name"}
                                  </p>
                                  <div className="text-xs text-gray-500">
                                    Position: {contestant.rank_position}
                                  </div>
                                </div>

                                {/* Points & Badges */}
                                <div className="text-right">
                                  <p className="text-sm font-semibold text-blue-600 primary_text_color">
                                    {contestant.points || 0}{" "}
                                    {lang?.points || "Points"}
                                  </p>
                                  <p className="text-xs text-gray-600 primary_text_color">
                                    {subsbadgeCounts[
                                      contestant.contest_member_id
                                    ] || 0}{" "}
                                    {lang?.badges || "Badges"}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="bg-white col-span-12 flex w-full flex-col items-center justify-center h-[15rem] drop-shadow-md border border-dashed border-gray-400 rounded-md">
                        <div className="flex w-full  flex-col items-center justify-center">
                          <NoData />
                          <h1 className="text-xl font-semibold text-black mt-2">
                            {lang?.no_participants_found ||
                              " No participants found"}
                          </h1>
                          <p className="text-gray-500 text-base font-medium">
                            {lang?.please_finish_the_contest ||
                              "Please finish the contest"}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* table */}
                    {Array.isArray(nextfiveData) && nextfiveData.length > 0 && (
                      <div className="p-4">
                        <div className="bg-white">
                          <div className="border border-gray-300 p-4 rounded-md">
                            {/* Header Row */}
                            <div className="grid grid-cols-4 md:grid-cols-4 gap-4 md:pl-6 pl-2 mb-3 font-semibold text-gray-700">
                              <div className="text-[10px] md:text-sm">
                                {lang?.position || "Position"}
                              </div>
                              <div className="text-[10px] md:text-sm">
                                {lang?.participants || "Participants"}
                              </div>
                              <div className="text-[10px] md:text-sm pl-2">
                                {lang?.badges || "Badges"}
                              </div>
                              <div className="text-[10px] md:text-sm">
                                {lang?.points || "Points"}
                              </div>
                            </div>

                            {/* Scrollable Data Rows */}
                            <div className="pr-2 space-y-2">
                              {nextfiveData.map((item, index) => (
                                <div
                                  key={index}
                                  className="bg-[#F9F9F9] grid grid-cols-4 gap-4 p-4 pl-8 rounded-md border border-[#C7C7C7]"
                                >
                                  <div className="text-[#0274F7] primary_text_color text-[12px] md:text-sm">
                                    {item?.rank_position}
                                  </div>
                                  <div className="text-gray-600 text-[12px] md:text-sm">
                                    {item?.name}
                                  </div>
                                  <div className="text-gray-600 pl-4 text-[12px] md:text-sm">
                                    {subsbadgeCountsNxt[item.contest_member_id]
                                      ? subsbadgeCountsNxt[
                                          item.contest_member_id
                                        ]
                                      : 0}{" "}
                                  </div>
                                  <div className="md:pl-6 pl-3">
                                    <span className="primary_border_color  px-1 py-1  md:px-5 md:py-1 rounded-md border border-[#0274F7] ">
                                      <span className="text-[#0274F7] primary_text_color text-[12px] md:text-sm">
                                        {item?.points}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Dialog.Panel>
          </Transition.Child>
          {/* </div> */}
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default Leaderboard;
